<script>
import { Bar, mixins } from 'vue-chartjs'
import { localeString } from '@/config/helpers.js'

export default {
  extends: Bar,
  mixins: [mixins.reactiveProp],
  props: {
    chartData: Object,
    configUpdate: Object,
    isCurrency: Boolean,
    isPercent: Boolean,
    isInteger: Boolean,
  },
  computed: {
    chartConfig() {
      if (this.configUpdate) return { ...this.configDefault, ...this.configUpdate }
      else return this.configDefault
    },
    configDefault() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        elements: {
          line: {
            tension: 0,
          },
          point: {
            radius: 1,
          },
        },
        animation: {
          duration: 0,
        },
        layout: {
          padding: {
            top: 20,
          },
        },
        hover: {
          animationDuration: 0,
        },
        responsiveAnimationDuration: 0,
        tooltips: {
          mode: 'index',
          intersect: false,
          callbacks: {
            label: (tooltip) => this.valueFormatter(tooltip.yLabel),
          },
        },
        legend: {
          display: false,
        },
        scales: {
          yAxes: [
            {
              ticks: {
                callback: this.valueFormatter,
                beginAtZero: true,
              },
            },
          ],
          xAxes: [
            {
              maxBarThickness: 50,
            },
          ],
        },
        plugins: {
          datalabels: {
            backgroundColor: 'rgba(248, 249, 250, 0.82)',
            anchor: 'end',
            align: 'end',
            borderRadius: 4,
            color: 'rgba(0, 0, 0, 0.54)',
            formatter: this.valueFormatter,
          },
        },
      }
    },
  },
  mounted() {
    this.renderChart(this.chartData, this.chartConfig)
  },
  methods: {
    valueFormatter(value) {
      if (this.isCurrency) return `R$ ${localeString(value, 2)}`
      if (this.isPercent) return `${localeString(value, 1)}%`
      if (this.isInteger) return localeString(value, 0)
      return localeString(value, 1)
    },
  },
}
</script>

<style lang="scss">
.encarte-chart {
  width: 100%;
  max-width: 650px;
}
@media print {
  .encarte-chart {
    position: relative;
    right: 30px;
  }
}
</style>
